import React, { useEffect, useState } from 'react';

import connect from 'react-redux/es/connect/connect';
import { InputWrapper } from 'react-lib/dist/components-es';
import GridColumnInputWrapper from '../../../common/GridColumnInputWrapper';

function CmrClassContainer(props) {
  const cmrClassIsAutomaticallyFilled = () => {
    const { chemicalProduct } = props.values;

    return (
      chemicalProduct.hazardStatements &&
      chemicalProduct.hazardStatements.some(h => h && h.cmrClasses && h.cmrClasses.length > 0)
    );
  };

  const [cmrClassIsAutFilled, setCmrClassIsAutFilled] = useState(cmrClassIsAutomaticallyFilled());

  useEffect(() => {
    if (props.cmrClassCalculation) updateCmrClass(props.values.chemicalProduct);
  }, [props.cmrClassCalculation]);

  useEffect(() => {
    if (!cmrClassIsAutFilled && props.cmrClassCalculation)
      props.setFieldValue('chemicalProduct.cmrClass', '');
  }, [cmrClassIsAutFilled]);

  const getCmrClassesOfHazardStatements = hazardStatements => {
    let cmrClassesArray = [];
    if (hazardStatements)
      hazardStatements.forEach(h => (cmrClassesArray = cmrClassesArray.concat(h.cmrClasses)));
    cmrClassesArray = cmrClassesArray.filter(c => c.cmrClass).map(c => c.cmrClass);
    return cmrClassesArray;
  };

  const calculateCmrClass = chemicalProduct => {
    let cmrClasses = getCmrClassesOfHazardStatements(chemicalProduct.hazardStatements);
    cmrClasses = [...new Set(cmrClasses)].sort(); //unique sorted values only as string
    cmrClasses = cmrClasses.join(', ');

    const regex = /((.)[^,]+), (?=\2|$)/gi;
    return cmrClasses.replace(regex, '$1/');
  };

  const updateCmrClass = chemicalProduct => {
    const { setFieldValue } = props;
    let newCmrClass = calculateCmrClass(chemicalProduct);

    setCmrClassIsAutFilled(cmrClassIsAutomaticallyFilled());

    if (newCmrClass) setFieldValue('chemicalProduct.cmrClass', newCmrClass);
  };

  return (
    <GridColumnInputWrapper
      {...props}
      value={props.values.chemicalProduct.cmrClass || ''}
      name="chemicalProduct.cmrClass"
      label="chemical.product.details.page.chemical.container.cmr.class.input"
      disabled={props.disabled || props.chemicalProductDisabled || cmrClassIsAutomaticallyFilled()}
      render={props => <InputWrapper {...props} />}
    />
  );
}

const mapStateToProps = state => ({
  cmrClassCalculation: state.chemicalProducts.cmrClassCalculation
});

export default connect(mapStateToProps, null)(CmrClassContainer);
